const Header = () => {
    return (
      <div className="header">
          <h1>Header</h1>
      </div>
    );
  }
  
  export default Header;
  